import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import { Marker, Polyline, Polygon } from '@react-google-maps/api';
import { markerConfig } from '@constants/component-configs';
import { getTrayLayer, getHoverLayerId, getTrayLayersIds, isAnyTrayItemHovered } from '@selectors/map-selector';
import { getLayerIcon } from '@utils/icon-utils';
import { generatePath, generatePolygonPaths, getPointShapeCoords } from '@utils/map-utils';
import { isLayerMarkerVisible } from '@utils/markers-utils';

class LayerFigure extends Component {

  getStyle = () => {
    const { attrs } = this.props.layer;
    const { mapStyle, styleCondition } = this.props;
    if (styleCondition) {
      const styles = mapStyle[attrs[styleCondition]];
      if (styles) {
        return cloneDeep(styles);
      }
    }
    return cloneDeep(mapStyle);
  };

  getMapStyle = () => {
    const mapStyle = this.getStyle();
    if (!mapStyle) {
      return {};
    }
    return mapStyle;
  };

  render() {
    const { markerVisible } = this.props;
    if (!markerVisible) {
      return null;
    }
    const { id, shape } = this.props.layer;
    const { icon } = this.props;
    const mapStyle = this.getMapStyle();
    const figureId = `${this.props.name}-${id}`;
    const layerProps = {
      options: { ...mapStyle, clickable: false, zIndex: 0 },
      onMouseMove: this.onMouseMove,
      onMouseOver: this.onMouseMove
    };
    if (shape.type === 'Point') {
      const markerProps = {
        options: markerConfig.options
      };
      return (
        <Marker
          key={figureId}
          icon={getLayerIcon(icon, 0)}
          position={getPointShapeCoords(shape)}
          {...markerProps}
        />
      );
    } else
      if (shape.type === 'LineString') {
        const path = generatePath(shape.coordinates);
        const lines = [<Polyline key={figureId} path={path} {...layerProps} />];
        return lines;
      } else
        if (shape.type === 'MultiLineString') {
          const lines = [];
          shape.coordinates.forEach((coords, index) => {
            const path = generatePath(coords);
            lines.push(<Polyline key={`${figureId}-${index}`} path={path} {...layerProps} />);
          });
          return lines;
        }
    if (shape.type === 'Polygon') {
      const polygonPath = generatePolygonPaths(shape.coordinates);
      return (
        <div>
          <Polygon key={figureId} paths={polygonPath} {...layerProps} />
          {mapStyle &&
          Object.prototype.hasOwnProperty.call(mapStyle, 'icons') &&
          <Polyline key={`outline-${figureId}`} path={generatePath(shape.coordinates[0])} {...layerProps} />
          }
        </div>
      );
    } else
      if (shape.type === 'MultiPolygon') {
        return shape.coordinates.map((coords, index) => (
          <div key={`wrapper-${figureId}-${index}`}>
            <Polygon
              key={`${figureId}-${index}`}
              paths={generatePolygonPaths(coords)}
              {...layerProps}
            />
            {mapStyle && Object.prototype.hasOwnProperty.call(mapStyle, 'icons') &&
            <Polyline
              key={`outline-${figureId}-${index}`}
              path={generatePath(coords[0])}
              {...layerProps}
            />
            }
          </div>
        ));
      }
    return null;
  }
}

LayerFigure.propTypes = {
  icon: PropTypes.string,
  id: PropTypes.number,
  isAnyTrayItemHovered: PropTypes.bool,
  layer: PropTypes.object,
  mapStyle: PropTypes.object,
  markerVisible: PropTypes.bool,
  name: PropTypes.string,
  styleCondition: PropTypes.string,
  trayEntity: PropTypes.object,
  trayHoverId: PropTypes.number,
  trayItemIds: PropTypes.object
};

const mapStateToProps = (state, props) => {
  const trayEntity = getTrayLayer(state);
  const trayHoverId = getHoverLayerId(state);
  const { layers } = state;
  const {
    icon,
    map_style: mapStyle,
    style_condition: styleCondition
  } = layers[props.name];
  const markerVisible = isLayerMarkerVisible(state, props.name, props.layer);
  return {
    icon,
    isAnyTrayItemHovered: isAnyTrayItemHovered(state),
    mapStyle,
    markerVisible,
    styleCondition,
    trayEntity,
    trayItemIds: getTrayLayersIds(state),
    trayHoverId
  };
};

export default connect(mapStateToProps, { })(LayerFigure);
